<script setup lang="ts">
/* eslint-env vue/setup-compiler-macros */
import { computed, ref } from 'vue';
import EmptyValueDisplay from '@/components/ui/EmptyValueDisplay.vue';

const props = defineProps<{
    ssn: string | null | undefined
}>();

const visible = ref(false);
const normalizedSsn = computed(() => {
    const value = props.ssn?.trim();

    if (!value || value === '-' || value === '—') {
        return null;
    }

    return value;
});

function maskSsn(ssn: string): string {
    const parts = ssn.split('-');
    if (parts.length === 3) {
        return `***-**-${parts[2]}`;
    }
    return ssn;
}
</script>

<template>
    <EmptyValueDisplay v-if="!normalizedSsn" />
    <span v-else class="ssn-display">
        <span class="ssn-display__value">{{ visible ? normalizedSsn : maskSsn(normalizedSsn) }}</span>
        <button
            type="button"
            class="ssn-display__toggle"
            :aria-label="visible ? 'Hide SSN' : 'Show SSN'"
            @click.stop="visible = !visible"
        >
            <i :class="visible ? 'pi pi-eye-slash' : 'pi pi-eye'" />
        </button>
    </span>
</template>

<style lang="scss" scoped>
.ssn-display {
    display: inline-flex;
    align-items: center;
    gap: 6px;

    &__value {
        //font-variant-numeric: tabular-nums;
        //letter-spacing: 0.01em;
        font-weight: 500;
    }

    &__toggle {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        background: none;
        border: none;
        cursor: pointer;
        color: rgba($black-color, 0.45);
        line-height: 1;
        transition: color 0.15s;

        &:hover {
            color: $black-color;
        }

        i {
            font-size: 14px;
        }
    }
}
</style>
